import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { G1ListComponent } from './list/g1-list/g1-list.component';
import { G1AccessComponent } from './access/g1-access/g1-access.component';
import { H1AccessComponent } from './access/h1-access/h1-access.component';
import { H2AccessComponent } from './access/h2-access/h2-access.component';
import { H3AccessComponent } from './access/h3-access/h3-access.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { DateComponent } from './components/date/date.component';
import { ClockComponent } from './components/clock/clock.component';
import { HomeComponent } from './home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from './components/footer/footer.component';
import * as $ from 'jquery';
import { MobileFooterComponent } from './components/mobile-footer/mobile-footer.component';
import { MatButtonModule, MatToolbarModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { G2ListComponent } from './list/g2-list/g2-list.component';
import { G2AccessComponent } from './access/g2-access/g2-access.component';
import { G3ListComponent } from './list/g3-list/g3-list.component';
import { G4ListComponent } from './list/g4-list/g4-list.component';
import { H1ListComponent } from './list/h1-list/h1-list.component';
import { H2ListComponent } from './list/h2-list/h2-list.component';
import { G3AccessComponent } from './access/g3-access/g3-access.component';
import { G4AccessComponent } from './access/g4-access/g4-access.component';
import { S1AccessComponent } from './access/s1-access/s1-access.component';
import { S2AccessComponent } from './access/s2-access/s2-access.component';
import { S3AccessComponent } from './access/s3-access/s3-access.component';
import { S4AccessComponent } from './access/s4-access/s4-access.component';
import { S5AccessComponent } from './access/s5-access/s5-access.component';
import { S6AccessComponent } from './access/s6-access/s6-access.component';
import { S7AccessComponent } from './access/s7-access/s7-access.component';
import { S8AccessComponent } from './access/s8-access/s8-access.component';
import { S9AccessComponent } from './access/s9-access/s9-access.component';
import { S10AccessComponent } from './access/s10-access/s10-access.component';
import { S11AccessComponent } from './access/s11-access/s11-access.component';
import { S12AccessComponent } from './access/s12-access/s12-access.component';
import { S13AccessComponent } from './access/s13-access/s13-access.component';
import { S14AccessComponent } from './access/s14-access/s14-access.component';
import { S15AccessComponent } from './access/s15-access/s15-access.component';
import { S16AccessComponent } from './access/s16-access/s16-access.component';
import { S17AccessComponent } from './access/s17-access/s17-access.component';
import { S18AccessComponent } from './access/s18-access/s18-access.component';
import { S19AccessComponent } from './access/s19-access/s19-access.component';
import { S20AccessComponent } from './access/s20-access/s20-access.component';
import { S21AccessComponent } from './access/s21-access/s21-access.component';
import { S22AccessComponent } from './access/s22-access/s22-access.component';
import { S23AccessComponent } from './access/s23-access/s23-access.component';
import { S24AccessComponent } from './access/s24-access/s24-access.component';
import { S25AccessComponent } from './access/s25-access/s25-access.component';
import { S26AccessComponent } from './access/s26-access/s26-access.component';
import { S27AccessComponent } from './access/s27-access/s27-access.component';
import { S28AccessComponent } from './access/s28-access/s28-access.component';
import { S29AccessComponent } from './access/s29-access/s29-access.component';
import { S30AccessComponent } from './access/s30-access/s30-access.component';
import { S31AccessComponent } from './access/s31-access/s31-access.component';
import { S32AccessComponent } from './access/s32-access/s32-access.component';
import { S33AccessComponent } from './access/s33-access/s33-access.component';
import { S34AccessComponent } from './access/s34-access/s34-access.component';
import { S35AccessComponent } from './access/s35-access/s35-access.component';
import { S1ListComponent } from './list/s1-list/s1-list.component';
import { S2ListComponent } from './list/s2-list/s2-list.component';
import { S3ListComponent } from './list/s3-list/s3-list.component';
import { S4ListComponent } from './list/s4-list/s4-list.component';
import { S5ListComponent } from './list/s5-list/s5-list.component';
import { S6ListComponent } from './list/s6-list/s6-list.component';
import { S7ListComponent } from './list/s7-list/s7-list.component';
import { S8ListComponent } from './list/s8-list/s8-list.component';
import { S9ListComponent } from './list/s9-list/s9-list.component';
import { S10ListComponent } from './list/s10-list/s10-list.component';
import { S11ListComponent } from './list/s11-list/s11-list.component';
import { S12ListComponent } from './list/s12-list/s12-list.component';
import { S13ListComponent } from './list/s13-list/s13-list.component';
import { S14ListComponent } from './list/s14-list/s14-list.component';
import { S15ListComponent } from './list/s15-list/s15-list.component';
import { S16ListComponent } from './list/s16-list/s16-list.component';
import { S17ListComponent } from './list/s17-list/s17-list.component';
import { S18ListComponent } from './list/s18-list/s18-list.component';
import { S19ListComponent } from './list/s19-list/s19-list.component';
import { S20ListComponent } from './list/s20-list/s20-list.component';
import { S21ListComponent } from './list/s21-list/s21-list.component';
import { S22ListComponent } from './list/s22-list/s22-list.component';
import { S23ListComponent } from './list/s23-list/s23-list.component';
import { S24ListComponent } from './list/s24-list/s24-list.component';
import { S25ListComponent } from './list/s25-list/s25-list.component';
import { S26ListComponent } from './list/s26-list/s26-list.component';
import { S27ListComponent } from './list/s27-list/s27-list.component';
import { S28ListComponent } from './list/s28-list/s28-list.component';
import { S29ListComponent } from './list/s29-list/s29-list.component';
import { S30ListComponent } from './list/s30-list/s30-list.component';
import { S31ListComponent } from './list/s31-list/s31-list.component';
import { S32ListComponent } from './list/s32-list/s32-list.component';
import { S33ListComponent } from './list/s33-list/s33-list.component';
import { S34ListComponent } from './list/s34-list/s34-list.component';
import { S35ListComponent } from './list/s35-list/s35-list.component';



@NgModule({
  declarations: [
    AppComponent,
    DateComponent,
    ClockComponent,
    NavbarComponent,
    FooterComponent,
    S1AccessComponent,
    S2AccessComponent,
    S3AccessComponent,
    S4AccessComponent,
    S5AccessComponent,
    S6AccessComponent,
    S7AccessComponent,
    S8AccessComponent,
    S9AccessComponent,
    S10AccessComponent,
    S11AccessComponent,
    S12AccessComponent,
    S13AccessComponent,
    S14AccessComponent,
    S15AccessComponent,
    S16AccessComponent,
    S17AccessComponent,
    S18AccessComponent,
    S19AccessComponent,
    S20AccessComponent,
    S21AccessComponent,
    S22AccessComponent,
    S23AccessComponent,
    S24AccessComponent,
    S25AccessComponent,
    S26AccessComponent,
    S27AccessComponent,
    S28AccessComponent,
    S29AccessComponent,
    S30AccessComponent,
    S31AccessComponent,
    S32AccessComponent,
    S33AccessComponent,
    S34AccessComponent,
    S35AccessComponent,
    G1ListComponent,
    G2ListComponent,
    G3ListComponent,
    G4ListComponent,
    H1ListComponent,
    H2ListComponent,
    S1ListComponent,
    S2ListComponent,
    S3ListComponent,
    S4ListComponent,
    S5ListComponent,
    S6ListComponent,
    S7ListComponent,
    S8ListComponent,
    S9ListComponent,
    S10ListComponent,
    S11ListComponent,
    S12ListComponent,
    S13ListComponent,
    S14ListComponent,
    S15ListComponent,
    S16ListComponent,
    S17ListComponent,
    S18ListComponent,
    S19ListComponent,
    S20ListComponent,
    S21ListComponent,
    S22ListComponent,
    S23ListComponent,
    S24ListComponent,
    S25ListComponent,
    S26ListComponent,
    S27ListComponent,
    S28ListComponent,
    S29ListComponent,
    S30ListComponent,
    S31ListComponent,
    S32ListComponent,
    S33ListComponent,
    S34ListComponent,
    S35ListComponent,
    G1AccessComponent,
    H1AccessComponent,
    H2AccessComponent,
    H3AccessComponent,
    G2AccessComponent,
    G3AccessComponent,
    G4AccessComponent,
    HomeComponent,
    MobileFooterComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MatButtonModule,
    MatToolbarModule
  ],
  providers: [],
  bootstrap: [AppComponent, NavbarComponent], 
})
export class AppModule { }
